import { AxiosInstance } from 'axios';

export type OrderTenderAcceptRequest = { orderGuid: string };
export type OrderTenderDeclineRequest = { orderGuid: string; reason: string };

export class OrderTenderService {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  accept(request: OrderTenderAcceptRequest) {
    return this.instance.put(`/order/${request.orderGuid}/tender/accept`);
  }

  decline(request: OrderTenderDeclineRequest) {
    return this.instance.put(`/order/${request.orderGuid}/tender/reject`, {
      reason: request.reason,
    });
  }
}
